import * as React from 'react';
import { AccordionHeaderCore, } from '@core-front/accordion';
import Icon from '@telia-front/icon';
import AccordionArrow from '../accordion-arrow/accordion-arrow';
import { AccordionItemContext, } from '../accordion-item/accordion-item';
export default class AccordionHeader extends React.Component {
    getCheck() {
        return (React.createElement("span", { className: "accordion__check" },
            React.createElement(Icon, { className: "accordion__check-icon", align: "none", modifiers: "#check-round" })));
    }
    getArrowLocation() {
        if (this.context.hideHeaderOnOpen && this.context.isMobile) {
            return 'header';
        }
        if (this.context.hideHeaderOnOpen) {
            return;
        }
        return 'inner';
    }
    render() {
        return (React.createElement(AccordionHeaderCore, Object.assign({}, this.props, { asideContent: this.context.checkable && this.getCheck(), components: {
                AccordionArrow,
            }, arrowLocation: this.getArrowLocation(), headerRef: this.context.headerRef })));
    }
}
AccordionHeader.contextType = AccordionItemContext;
